import { BadgeProps, Badge as ChakraBadge } from '@chakra-ui/react';
import React from 'react';

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>((props, ref) => (
  <ChakraBadge ref={ref} borderRadius="full" fontWeight="medium" {...props} />
));

export default Badge;
